<div class="columns">
  <div class="column dicom-data-column">
    <h3>{{ 'viewer.serie.scc.dicom_data' | translate }}</h3>
    <!-- Bind dicomData to a local template variable -->
    <ng-container *ngIf="input?.dicomData as dicomData">
      <!-- Check if tags exists -->
      <ul *ngIf="dicomData?.tags as tags">
        <ng-container *ngFor="let entry of objectEntries(tags)">
          <li>
            <strong>{{ entry.key }}: </strong>
            <!-- If the value is a simple string or an array of strings, display it -->
            <ng-container *ngIf="isSimpleValue(entry.value); else recursiveDisplay">
              <span *ngIf="isArray(entry.value); else singleValue">
                <span *ngFor="let val of entry.value">{{ val }}</span>
              </span>
              <ng-template #singleValue>
                {{ entry.value }}
              </ng-template>
            </ng-container>
            <!-- Otherwise, use the recursive template to process nested tags -->
            <ng-template #recursiveDisplay>
              <ng-container *ngTemplateOutlet="recursive; context:{ data: entry.value }"></ng-container>
            </ng-template>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </div>
</div>

<!-- Recursive template for nested tags -->
<ng-template #recursive let-data="data">
  <!-- If data is an object, iterate over its keys -->
  <ul *ngIf="isObject(data)">
    <ng-container *ngFor="let entry of objectEntries(data)">
      <li>
        <strong>{{ entry.key }}: </strong>
        <ng-container *ngIf="isSimpleValue(entry.value); else recursiveDisplayObj">
          <span *ngIf="isArray(entry.value); else singleValueObj">
            <span *ngFor="let val of entry.value">{{ val }}</span>
          </span>
          <ng-template #singleValueObj>
            {{ entry.value }}
          </ng-template>
        </ng-container>
        <ng-template #recursiveDisplayObj>
          <ng-container *ngTemplateOutlet="recursive; context:{ data: entry.value }"></ng-container>
        </ng-template>
      </li>
    </ng-container>
  </ul>
  <!-- If data is an array (and not a simple array of strings), iterate over its items -->
  <ul *ngIf="isArray(data) && !isSimpleValue(data)">
    <li *ngFor="let item of data">
      <ng-container *ngIf="isSimpleValue(item); else recursiveDisplayArray">
        {{ item }}
      </ng-container>
      <ng-template #recursiveDisplayArray>
        <ng-container *ngTemplateOutlet="recursive; context:{ data: item }"></ng-container>
      </ng-template>
    </li>
  </ul>
</ng-template>
